// extracted by mini-css-extract-plugin
export default {"acc-container":"Accordion_acc-container__DY3+2","contentHide":"Accordion_contentHide__6kgzC","contentShow":"Accordion_contentShow__C3lrb"};